import { Notification  } from "element-ui";
import axios from "axios";
import qs from 'qs';
import {Dialog} from "vant";
//pc本地服务
var baseURL = `https://${process.env.SERVER_HOST}/`
var http = `https://${process.env.SERVER_HOST}/web`;
//移动端的地址本地地址
var http2 = `https://${process.env.SERVER_HOST}/fh`;
//移动端医生端
var http3 = `https://${process.env.SERVER_HOST}/doctorlogin`;
//微信代付
var http4 = `https://${process.env.SERVER_HOST}/payment`;
//移动端的线上地址
const server = {
    state: {
        baseURL: baseURL,
        URL: http,
        uploadAction: http + "/upload/file",
        URL2: http2,
        URL3: http3,
        URL4: http4,
        isLogin: true,
    },
    mutations: {
        GET_IS_LOGIN(state, isLogin) {
            state.isLogin = isLogin;
        },
    },
    actions: {
        server(store, request) {
            // 拦截器
            axios.interceptors.response.use(response => {
                if (response) {
                    if (response.data) {
                        if (response.data.status === 601 || response.data.status === 10068 || response.data.status === 401) {
                            Notification.error("登录已失效,请重新登录");
                        } else {
                            return response;
                        }
                    }
                }
            }, (error) => {
              let status = error.response.data.status;
              if (status === 601 || status === 10068 || status === 401) {
                localStorage.setItem("token", "")
                Dialog.confirm({
                  title: '温馨提示',
                  message: "登录已失效，请重新登录",
                  confirmButtonText: '登录',
                  confirmButtonColor: '#409eff',
                }).then(() => {
                  store.commit("GET_IS_LOGIN", false);
                })
              }
            })

            // 配置请求参数
            var type = request.type;                                            // 请求类型
            var token = request.token;                                          // 请求类型
            var url = request.url;                                              // 请求名称
            var data = request.data ? request.data : {};                        // 请求数据

            // 配置传递参数
            var config;
            switch (type) {
                case "upload":
                    config = {
                        method: "post",
                        timeout: 10000,
                        baseURL: store.state.uploadAction,
                        data: data,
                    };
                    break;
                case "import":
                    config = {
                        method: "post",
                        timeout: 10000,
                        baseURL: store.state.URL,
                        url: url,
                        data: data,
                    };
                    break;
                case "ydd":
                    config = {
                        method: "post",
                        headers: {"Content-Type": "application/json;charset=UTF-8"},
                        timeout: 40000,
                        baseURL: store.state.URL2,
                        url: url,
                        data: data,
                    };
                    break;
                case "yddys":
                    config = {
                        method: "post",
                        headers: {"Content-Type": "application/json;charset=UTF-8"},
                        timeout: 40000,
                        baseURL: store.state.URL3,
                        url: url,
                        data: data,
                    };
                    break;
                case "wxdf":
                    config = {
                        method: "post",
                        headers: {"Content-Type": "application/json;charset=UTF-8"},
                        timeout: 40000,
                        baseURL: store.state.URL4,
                        url: url,
                        data: data,
                    };
                    break;
                case "get":
                    config = {
                        method: "get",
                        headers: {"Content-Type": "application/json;charset=UTF-8"},
                        timeout: 40000,
                        baseURL: store.state.baseURL,
                        url: url,
                        params: data,
                    };
                    break;
                case "post":
                    config = {
                        method: "post",
                        headers: {"Content-Type": "application/json;charset=UTF-8"},
                        timeout: 400000,
                        baseURL: store.state.baseURL,
                        url: url,
                        data: data,
                    };
                    break;
                case "put":
                    config = {
                        method: "put",
                        headers: {"Content-Type": "application/json;charset=UTF-8"},
                        timeout: 40000,
                        baseURL: store.state.baseURL,
                        url: url,
                        data: data,
                    };
                    break;
                case "delete":
                  config = {
                    method: "delete",
                    headers: {"Content-Type": "application/json;charset=UTF-8"},
                    timeout: 40000,
                    baseURL: store.state.baseURL,
                    url: url,
                    data: data,
                  };
                  break;
                default:
                    config = {
                        method: "post",
                        headers: {"Content-Type": "application/json;charset=UTF-8"},
                        timeout: 40000,
                        baseURL: store.state.URL,
                        url: url,
                        data: data,//qs.stringify()将对象 序列化成URL的形式，以&进行拼接。
                    };
                    break;
            }
            if (token){
              config.headers['Authorization'] = token
            }
            return axios(config);
        }
    }
};

export default server;



// WEBPACK FOOTER //
// ./src/store/modules/server.js